import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { useFolder } from "src/core/contexts/FolderContext";
import { useCloseMissionMutation } from "src/core/gql/graphql";
import { useToast } from "src/core/hooks/use-toast";

export const useCloseFile = (setOpen: (open: boolean) => void) => {
  const { t } = useTranslation();
  const { folderFile, refetch } = useFolder();
  const [closeMission] = useCloseMissionMutation();
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleClose = useCallback(async () => {
    try {
      setIsLoading(true);

      const closableMissions =
        folderFile.folderFile?.currentCustomerFolder?.missions?.filter(
          (mission: { __typename?: "Mission"; id: string; isClosable: boolean }) =>
            mission.isClosable
        ) || [];

      await Promise.all(
        closableMissions.map(
          async (mission: { __typename?: "Mission"; id: string; isClosable: boolean }) => {
            return closeMission({
              variables: {
                missionId: mission.id,
                statusComment: "Fin de mission",
              },
            });
          }
        )
      );

      await refetch();

      toast({
        description: t("form.closeFile.success"),
      });
    } catch (error) {
      console.error("useCloseFile::error", error);
      toast({
        description: t("form.closeFile.fail"),
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
      setOpen(false);
    }
  }, [
    folderFile.folderFile?.currentCustomerFolder?.missions,
    closeMission,
    refetch,
    toast,
    t,
    setOpen,
  ]);

  return {
    handleClose,
    isLoading,
  };
};
